const MAX_LENGTH = 1000;
const FALLBACK = '/';

const hasUnsafeCharacter = (value: string): boolean =>
  Array.from({ length: value.length }, (_, i) => value.charCodeAt(i)).some(
    (code) => code < 0x20 || code === 0x7f || code === 0x5c,
  );

/**
 * ログイン後の戻り先として安全な、サイト内のパスだけを通す(オープンリダイレクト対策)。
 * 単一の `/` で始まるもののみ。`//host`・`http://…`・`\`・制御文字・ログイン画面自身は '/' に戻す。
 */
export const safeRedirectPath = (raw: string | null | undefined): string => {
  if (typeof raw !== 'string' || raw.length === 0 || raw.length > MAX_LENGTH) return FALLBACK;
  if (!raw.startsWith('/') || raw.startsWith('//') || hasUnsafeCharacter(raw)) return FALLBACK;
  try {
    // 念のため、ダミーのオリジンに対して解決しても同一オリジンのままであることを確認する
    if (new URL(raw, 'http://app.invalid').origin !== 'http://app.invalid') return FALLBACK;
  } catch {
    return FALLBACK;
  }
  const pathname = raw.split(/[?#]/, 1)[0] ?? '';
  return pathname === '/login' || pathname.startsWith('/login/') ? FALLBACK : raw;
};
